import api from "../../api";

export class DataBancaViewModel {
    
    static async getDataBanca(processoId: string, bancaId: string): Promise<{ date: Date | null, startTime: Date | null, endTime: Date | null, isValid: boolean }> {
        interface ApiResponse {
            id: string;
            horaInicial: string;
            horaFinal: string;
            data: string;
            confirmada: boolean;
        }

        try {
            const response = await api.get(`processos/${processoId}/bancas/${bancaId}/dataDeBanca`);

            if (typeof response.data !== 'object' || !response.data.data || !response.data.horaInicial || !response.data.horaFinal) {
                return { date: null, startTime: null, endTime: null, isValid: false };
            }

            const resposta: ApiResponse = response.data;

            const date = new Date(resposta.data);
            const startTime = new Date(`${resposta.data}T${resposta.horaInicial}`);
            const endTime = new Date(`${resposta.data}T${resposta.horaFinal}`);

            if (isNaN(date.getTime()) || isNaN(startTime.getTime()) || isNaN(endTime.getTime())) {
                throw new Error('Valores de data ou hora inválidos');
            }

            return { date, startTime, endTime, isValid: true };
        } catch (error) {
            throw error
        }
    }

    static async postDataBanca(processoId: string, bancaId: string, data: string, inicio: string, fim: string): Promise<boolean> {
        const postData = {
            horaInicial: inicio,
            horaFinal: fim,
            data: data
        };

        try {
            const response = await api.post(`processos/${processoId}/bancas/${bancaId}/dataDeBanca`, postData);
            return response.status >= 200 && response.status < 300;        
        } catch (error: any) {
            throw error
        }
    }

    static async getRawDataBanca(processoId: string, bancaId: string): Promise<{ data: string | null, horaInicial: string | null, horaFinal: string | null, isValid: boolean }> {
        try {
            const response = await api.get(`processos/${processoId}/bancas/${bancaId}/dataDeBanca`);

            if (typeof response.data !== 'object' || !response.data.data || !response.data.horaInicial || !response.data.horaFinal) {
                return { data: null, horaInicial: null, horaFinal: null, isValid: false };
            }

            return {
                data: response.data.data,
                horaInicial: response.data.horaInicial,
                horaFinal: response.data.horaFinal,
                isValid: true
            };
        } catch (error) {
            throw error;
        }
    }

    static async patchDataBanca(processoId: string, bancaId: string, data: string, inicio: string, fim: string): Promise<boolean> {
        interface ApiPost {
            horaInicial: string;
            horaFinal: string;
            data: string;
        }

        const postData: ApiPost = {
            horaInicial: `${inicio}`,
            horaFinal: `${fim}`,
            data: data
        };

        try {
            const response = await api.patch(`processos/${processoId}/bancas/${bancaId}/dataDeBanca`, postData);
            return response.status >= 200 && response.status < 300;
        } catch (error) {
            throw error            
        }
    }

}

